<app-help-page mainVideo="managing-dimensions"
               [tutorials]="['dimensions-management-page']"
               [videos]="['managing-dimensions']"></app-help-page>
